/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injector, ProviderToken } from '@angular/core';

export class SnackbarInjector implements Injector {
  constructor(
    private _parentInjector: Injector,
    private _additionalTokens: WeakMap<ProviderToken<any>, any>
  ) {}

  get<T>(token: ProviderToken<T>, notFoundValue?: T): T {
    const value = this._additionalTokens.get(token);
    if (value !== undefined) return value;

    return this._parentInjector.get(token, notFoundValue);
  }
}
